module.exports = __webpack_public_path__ + "static/img/kh-14.bcfe52e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-14.png
// module id = PceH
// module chunks = 5